export default "__VITE_ASSET__CH_LqVSr__"